import React from "react";
import { Box, Stack, Chip } from "@mui/material";
import { CheckCircleOutlined, RadioButtonUncheckedOutlined } from "@mui/icons-material";
import Body3 from "../typography/body-03";
import styles from "./index.module.scss";

const PathSelectionCard = ({
	selected,
	onSelect,
	badge,
	badgeColor,
	title,
	description,
	steps,
	recommended,
	disabled = false,
}) => {
	return (
		<Box
			className={`${styles.card} ${selected ? styles.cardSelected : ""} ${
				recommended ? styles.cardRecommended : ""
			} ${disabled ? styles.cardDisabled : ""}`}
			onClick={disabled ? undefined : onSelect}
			role="button"
			aria-disabled={disabled}
			tabIndex={disabled ? -1 : 0}
			onKeyDown={(e) => !disabled && e.key === "Enter" && onSelect()}
		>
			<Stack direction="row" alignItems="flex-start" justifyContent="space-between" mb={1}>
				<Chip
					label={badge}
					size="small"
					className={`${styles.badge} ${
						badgeColor === "green" ? styles.badgeGreen : styles.badgeGrey
					}`}
				/>
				{selected ? (
					<CheckCircleOutlined className={styles.selectedIcon} />
				) : (
					<RadioButtonUncheckedOutlined className={styles.unselectedIcon} />
				)}
			</Stack>

			<Box className={styles.title}>{title}</Box>

			<Body3 text={description} extraClass={styles.description} />

			<Stack direction="column" gap={0.5} mt={2}>
				{steps.map((step, idx) => (
					<Stack key={idx} direction="row" alignItems="center" gap={1}>
						<Box className={styles.stepDot} />
						<span className={styles.stepText}>{step}</span>
					</Stack>
				))}
			</Stack>
		</Box>
	);
};

export default PathSelectionCard;
